import {validateEmail} from "./validation";

// let emailHasError = false;

export function loginPageLogic()  {
  if (!window.location.href.includes("login") && !window.location.href.includes("restore")) {
    return;
  }
  const emailInput = document.getElementById("email");
  const loginSubmit = document.getElementById("submit");
  if (!emailInput || !loginSubmit) {
    return
  }

  const validateEmailInput = (value = emailInput.value) => {
    if (validateEmail(value)) {
      loginSubmit.classList.remove("ui-button--disabled");
      emailInput.classList.remove("ui-input--error");
      return true
    } else {
      loginSubmit.classList.add("ui-button--disabled");
      emailInput.classList.add("ui-input--error");
      return false
    }
  }
  ["input", "change"].every(property => {
    emailInput.addEventListener(property, (event) => {
      if (emailInput.classList.contains("ui-input--error")) {
        validateEmailInput(event.target.value)
      }
    });
  })
  emailInput.addEventListener("blur", () => {
    validateEmailInput();
  });
  loginSubmit.addEventListener("click", (event) => {
    if (!validateEmailInput()) {
      event.preventDefault();
    }
  });
}